import documentsSidebarMenuActionCreators from "Areas/Sidebar/Documents/redux/actionCreators";
import { getActiveDocument, getActiveDocumentId, getDocumentsInProgress, getObjects, getObjectsInProgress } from "Areas/Sidebar/Documents/redux/selectors";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import { Permissions, security } from "Common/permissions";
import { connect } from "react-redux";
import documentDetailsActionCreators from "../documentDetails/redux/actionCreators";
import { getFinalReadOnlyMode } from "../documentDetails/redux/getReadOnlyMode";
import { getInnerObjectsSelectedIds } from "../documentDetails/redux/selectors";
import actionCreators, { abortActionCreators } from "./redux/actionCreators";
import { getAvailableDocumentObjectIds, getColumns, getDocumentTableDataInProgress, getInProgress, getInitialNodesSource, getNodesSource, getRows, getSelectedDocumentObjectIds } from "./redux/selectors";
import Table from "./table";
const canEdit = security.isAllowed([Permissions.DocumentsEdit]);
const onCancelTableData = (documentId) => {
    abortActionCreators.cancelGetDocumentTableData(documentId);
};
const mapStateToProps = (state) => {
    var _a;
    return ({
        key: getActiveDocumentId(state) || "",
        documentId: getActiveDocumentId(state),
        documentName: (_a = getActiveDocument(state)) === null || _a === void 0 ? void 0 : _a.Name,
        columns: getColumns(state),
        data: getRows(state),
        initialNodeSources: getInitialNodesSource(state),
        nodeSources: getNodesSource(state),
        selectedRowIds: getInnerObjectsSelectedIds(state),
        documentObjects: getObjects(state),
        inProgress: getInProgress(state) || getObjectsInProgress(state) || getDocumentsInProgress(state),
        getTableDataInProgress: getDocumentTableDataInProgress(state),
        canEdit,
        readOnlyMode: getFinalReadOnlyMode(state),
        availableDocumentObjectIds: getAvailableDocumentObjectIds(state),
        selectedDocumentObjectIds: getSelectedDocumentObjectIds(state),
        onCancelTableData
    });
};
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => {
        dispatch(documentsSidebarMenuActionCreators.getObjects());
        dispatch(documentsSidebarMenuActionCreators.setNavigateTo(undefined));
    },
    onGetAvailableDocumentObjectIds: (documentId) => dispatch(actionCreators.getAvailableDocumentObjectIds(documentId)),
    onSelectDocumentObjects: (documentId, documentObjectIds) => dispatch(actionCreators.setSelectDocumentObjectIds(documentId, documentObjectIds)),
    onGetTableData: (documentId, documentObjectIds) => dispatch(actionCreators.getDocumentTableData(documentId, documentObjectIds, null, () => {
        dispatch(documentDetailsActionCreators.setInnerObjectsSelectedIds([], documentId, DOCUMENT_TYPE.TABLE));
    }, true)),
    onChangeSelected: (documentId, nodeIds, rowIds) => {
        if (!nodeIds.length) {
            dispatch(documentDetailsActionCreators.setInnerObjectsSelectedIds(rowIds, documentId, DOCUMENT_TYPE.TABLE));
        }
        else {
            dispatch(actionCreators.getNodeSources(documentId, nodeIds, () => {
                dispatch(documentDetailsActionCreators.setInnerObjectsSelectedIds(rowIds, documentId, DOCUMENT_TYPE.TABLE));
            }));
        }
    },
    onGetPreview: (largeAttributeId, completed, rejected) => dispatch(documentDetailsActionCreators.getGraphNodeImageContent(largeAttributeId, completed, rejected)),
    onChangeTableData: (documentId, diff) => dispatch(actionCreators.updateTableData(documentId, diff)),
    onChangeNodeSources: (documentId, nodesSource, onlyDiffSources, updateInitialNodes) => dispatch(actionCreators.setNodeSources(documentId, nodesSource, onlyDiffSources, updateInitialNodes)),
    onSaveTableData: (documentId, initialNodeSources, nodesSource) => dispatch(actionCreators.saveDocumentTableData(documentId, initialNodeSources, nodesSource))
});
export default connect(mapStateToProps, mapDispatchToProps)(Table);
